export * from './actionTypes';
export * from './homeTypes';
export * from './questionSlugs';

export const FORM_NAME = 'intro';
